<template>
  <el-dialog :append-to-body="true" id="contact-list-layer" title="联系人列表" :visible.sync="dialogVisible" width="600px"
    :center="true">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="50px">
      <el-form-item label="账号" prop="account">
        <el-input
          v-model="queryParams.account"
          placeholder="请输入联系人账号"
          clearable
          size="small"
          @keyup.enter.native="toQuery"
        />
      </el-form-item>
      <el-form-item label="标签">
        <el-select size="small" v-model="queryParams.label" clearable placeholder="联系人标签" class="filter-item" style="width: 130px">
          <el-option v-for="item in labelList" :key="item.id" :label="item.tagName" :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="toQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="data" size="small" ref="multipleTable" @select="handleSelectionChange"
      style="width: 475px; margin: 0 auto;">
      <el-table-column prop="userName" label="账号" align="center"></el-table-column>
      <el-table-column prop="nickName" label="名称" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.nickName" placement="top" effect="light">
            <div class="scope-content">
              <span>{{scope.row.nickName}}</span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="agentUserName" label="经办人账号" align="center"></el-table-column>
      <el-table-column prop="agentNickName" label="经办人姓名" align="center"></el-table-column>
      <el-table-column type="selection" width="55">
      </el-table-column>
    </el-table>

    <div class="dialog-btns">
      <el-button type="primary" :disabled="addok" @click="submit" class="btn-ok">确认添加</el-button>
      <el-button type="info" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import initData from '@/mixins/initData'
  import {
    mapState
  } from 'vuex'
  import { queryContactTagApi } from '@/api/sign/flow'
  export default {
    mixins: [initData],
    computed: mapState([
      'currentSpace'
    ]),
    data() {
      return {
        dialogVisible: false,
        addok: false,
        queryParams: {
          account: '',
          label: ''
        },
        userType: 1,  // 1 企业 2 个人
        labelList: [],
        // data: [
        //   {
        //     name: '张三',
        //     phone: '13011111111',
        //     companyName: '张三的企业',
        //   },
        //   {
        //     name: '李四',
        //     phone: '13011121111',
        //     companyName: '',
        //   }
        // ],
        // loading: false,
        sequence: 0,
        multipleSelection: [],
        slectData: {}
      }
    },
    methods: {
      // getContactListApi()
      beforeInit() {
        this.url = '/contract/getContactUserPage'
        this.params = {
          pageIndex: 1,
          pageSize: 10,
          userType: this.userType,
          companyId: this.currentSpace.companyId || '',
          userName: this.queryParams.account,
          tagIds: this.queryParams.label
        }
        this.queryContactTagHandle()
        return true
      },
      queryContactTagHandle() {
        queryContactTagApi({
          companyId: this.currentSpace.companyId,
          nocache: new Date().getTime()
        }).then(res => {
          console.log(res)
          if (res.code !== 200) {
            
          } else {
            this.labelList = res.data
          }
        }).catch(err => {
          console.log(err)
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val[val.length - 1]
        if (val.length > 0) {
          this.data.forEach(data => {
            if (data.nickName == this.multipleSelection.nickName && data.userName == this
              .multipleSelection.userName && data.agentNickName == this.multipleSelection.agentNickName && data.agentUserName == this.multipleSelection.agentUserName) {

            } else {
              this.$refs.multipleTable.toggleRowSelection(data, false)
            }
          })
        }

      },
      submit() {
        if (!this.multipleSelection.userName) {
          this.$message({
            showClose: true,
            message: '请选择联系人',
            type: 'warning'
          });
          return
        } else {
          var selectData = {}
          selectData.sequence = this.sequence
          selectData.multipleSelection = this.multipleSelection
          this.addok = true
          console.log(selectData)
          this.$emit('selectSignatory', selectData)
          this.cancel()
        }
      },
      cancel() {
        this.dialogVisible = false
        this.$refs.multipleTable.clearSelection()
      }
    }
  }
</script>
<style>
  #contact-list-layer .el-table__header .el-checkbox {
    display: none;
  }

  #contact-list-layer .el-table .cell {
    font-size: 14px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>

<style scoped>
  #contact-list-layer .dialog-btns {
    width: 475px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
</style>